/**
 * Depuis Des Lustres — Shopify Theme JS
 * Handles: gallery, lightbox, tabs, accordions, filter toggles, scroll animations
 */

(function () {
  'use strict';

  /* =========================================================================
     1. GALLERY
     ========================================================================= */
  function initGallery(container) {
    var items = container.querySelectorAll('.ddl-gallery__item');
    if (!items.length) return;

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        openLightbox(container, index);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(container, index);
        }
      });
    });
  }

  /* =========================================================================
     2. LIGHTBOX
     ========================================================================= */
  function openLightbox(galleryContainer, startIndex) {
    var lightbox = document.querySelector('.ddl-lightbox');
    if (!lightbox) return;

    var images = Array.from(galleryContainer.querySelectorAll('.ddl-gallery__img')).map(function (img) {
      return { src: img.src, alt: img.alt };
    });

    var currentIndex = startIndex || 0;
    var lbImg = lightbox.querySelector('.ddl-lightbox__img');
    var lbCounter = lightbox.querySelector('.ddl-lightbox__counter');
    var lbThumbs = lightbox.querySelector('.ddl-lightbox__thumbs');

    function update() {
      if (lbImg) {
        lbImg.src = images[currentIndex].src;
        lbImg.alt = images[currentIndex].alt;
      }
      if (lbCounter) lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;

      if (lbThumbs) {
        lbThumbs.querySelectorAll('.ddl-lightbox__thumb-btn').forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === currentIndex);
        });
        var activeBtn = lbThumbs.querySelectorAll('.ddl-lightbox__thumb-btn')[currentIndex];
        if (activeBtn) activeBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      // Show/hide nav buttons
      var prevBtn = lightbox.querySelector('.ddl-lightbox__prev');
      var nextBtn = lightbox.querySelector('.ddl-lightbox__next');
      if (prevBtn) prevBtn.style.display = currentIndex === 0 ? 'none' : '';
      if (nextBtn) nextBtn.style.display = currentIndex === images.length - 1 ? 'none' : '';
    }

    // Build thumbs
    if (lbThumbs) {
      lbThumbs.innerHTML = '';
      images.forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.className = 'ddl-lightbox__thumb-btn';
        btn.type = 'button';
        var imgEl = document.createElement('img');
        imgEl.src = img.src;
        imgEl.alt = img.alt;
        btn.appendChild(imgEl);
        btn.addEventListener('click', function (e) { e.stopPropagation(); currentIndex = i; update(); });
        lbThumbs.appendChild(btn);
      });
      lbThumbs.style.display = images.length <= 1 ? 'none' : '';
    }

    update();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Prev / Next
    var prevBtn = lightbox.querySelector('.ddl-lightbox__prev');
    var nextBtn = lightbox.querySelector('.ddl-lightbox__next');
    if (prevBtn) {
      prevBtn.onclick = function (e) { e.stopPropagation(); if (currentIndex > 0) { currentIndex--; update(); } };
    }
    if (nextBtn) {
      nextBtn.onclick = function (e) { e.stopPropagation(); if (currentIndex < images.length - 1) { currentIndex++; update(); } };
    }

    // Close
    var closeBtn = lightbox.querySelector('.ddl-lightbox__close');
    if (closeBtn) closeBtn.onclick = closeLightbox;
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lbImg) closeLightbox();
    });

    // Keyboard
    document.addEventListener('keydown', onLightboxKey);

    function onLightboxKey(e) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && currentIndex > 0) { currentIndex--; update(); }
      if (e.key === 'ArrowRight' && currentIndex < images.length - 1) { currentIndex++; update(); }
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onLightboxKey);
    }
  }

  function closeLightbox() {
    var lightbox = document.querySelector('.ddl-lightbox');
    if (lightbox) { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  /* =========================================================================
     3. TABS (product page — desktop)
     ========================================================================= */
  function initTabs(container) {
    var btns = container.querySelectorAll('.ddl-tab-btn');
    var panels = container.querySelectorAll('.ddl-tab-panel');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = container.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* =========================================================================
     4. ACCORDIONS (product page — mobile + filter sidebar)
     ========================================================================= */
  function initAccordion(el) {
    var trigger = el.querySelector('.ddl-accordion__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      el.classList.toggle('is-open');
    });
  }

  function initFilterSection(el) {
    var trigger = el.querySelector('.ddl-filter-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      el.classList.toggle('is-open');
    });
  }

  /* =========================================================================
     5. QUANTITY STEPPER
     ========================================================================= */
  function initQuantity(container) {
    var minusBtn = container.querySelector('.ddl-qty-btn[data-action="minus"]');
    var plusBtn  = container.querySelector('.ddl-qty-btn[data-action="plus"]');
    var input    = container.querySelector('.ddl-qty-value');
    if (!input) return;

    function getVal() { return parseInt(input.value, 10) || 1; }
    function setVal(v) {
      var max = parseInt(input.getAttribute('max') || '9999', 10);
      v = Math.max(1, Math.min(v, max));
      input.value = v;
      if (minusBtn) minusBtn.disabled = v <= 1;
      if (plusBtn)  plusBtn.disabled  = v >= max;
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { setVal(getVal() - 1); });
    if (plusBtn)  plusBtn.addEventListener('click',  function () { setVal(getVal() + 1); });
    input.addEventListener('change', function () { setVal(getVal()); });
    setVal(getVal());
  }

  /* =========================================================================
     6. VARIANT BUTTONS
     ========================================================================= */
  function initVariantButtons(form) {
    var btns = form.querySelectorAll('.ddl-variant-btn');
    var hiddenInput = form.querySelector('input[name="id"]');
    if (!btns.length || !hiddenInput) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) {
          hiddenInput.value = variantId;
          updatePriceDisplay(form, btn);
        }
      });
    });
  }

  function updatePriceDisplay(form, btn) {
    var price       = btn.getAttribute('data-price');
    var comparePrice = btn.getAttribute('data-compare-price');
    var priceEl     = form.closest('.ddl-product-layout')
                       ? form.closest('.ddl-product-layout').querySelector('.ddl-price')
                       : document.querySelector('.ddl-price');
    var compareEl   = priceEl ? priceEl.closest('.ddl-price-wrap').querySelector('.ddl-price--compare') : null;
    var savingEl    = priceEl ? priceEl.closest('.ddl-price-wrap').querySelector('.ddl-price--saving') : null;

    if (priceEl && price) {
      priceEl.textContent = formatMoney(parseInt(price, 10));
    }
    if (compareEl) {
      if (comparePrice && parseInt(comparePrice, 10) > parseInt(price || '0', 10)) {
        compareEl.textContent = formatMoney(parseInt(comparePrice, 10));
        compareEl.style.display = '';
        if (savingEl) {
          var discount = Math.round((1 - parseInt(price, 10) / parseInt(comparePrice, 10)) * 100);
          savingEl.textContent = 'Économisez ' + discount + '%';
          savingEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (savingEl) savingEl.style.display = 'none';
      }
    }
    // Update sticky bar prices
    var stickyPrice = document.getElementById('ddl-sticky-price');
    var stickyCompare = document.getElementById('ddl-sticky-compare');
    if (stickyPrice) stickyPrice.textContent = priceEl ? priceEl.textContent : '';
    if (stickyCompare) {
      stickyCompare.textContent = compareEl ? compareEl.textContent : '';
      stickyCompare.style.display = compareEl ? compareEl.style.display : 'none';
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  /* =========================================================================
     7. SCROLL ANIMATIONS
     ========================================================================= */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ddl-animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.ddl-animate').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* =========================================================================
     8. MOBILE FILTER TOGGLE
     ========================================================================= */
  function initMobileFilter(root) {
    root = root || document;
    var toggleBtn = root.querySelector('.ddl-mobile-filter-toggle');
    var sidebar   = root.querySelector('.ddl-collection-sidebar');
    if (!toggleBtn || !sidebar) return;

    toggleBtn.addEventListener('click', function () {
      var isOpen = sidebar.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        setTimeout(function () {
          sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    });
  }

  /* =========================================================================
     9. COLLECTION FILTERS (Shopify native filter form)

     On a real collection page, the filter/sort forms just GET-submit to
     collection.url — Shopify applies filters natively on that route. On a
     brand page (/pages/x), that same markup is rendered for a twin
     collection but the route can't apply filters, so instead we intercept
     submissions inside any [data-ddl-ajax-facets] root and fetch the
     twin collection's rendered section via handleFacetSubmit/fetchFacetsAjax.
     ========================================================================= */
  function handleFacetSubmit(form) {
    if (!form) return;
    var ajaxRoot = form.closest('[data-ddl-ajax-facets]');
    if (!ajaxRoot) { form.submit(); return; }
    var params = new URLSearchParams(new FormData(form));
    var base = form.getAttribute('action') || form.action;
    fetchFacetsAjax(ajaxRoot, base.split('?')[0] + '?' + params.toString());
  }

  function fetchFacetsAjax(root, targetUrl) {
    var sectionId = root.getAttribute('data-section-id') || 'ddl-main-collection';
    var sep = targetUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = targetUrl + sep + 'section_id=' + encodeURIComponent(sectionId);

    root.classList.add('is-loading');
    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('.ddl-collection-layout');
        if (!newRoot) { window.location.href = targetUrl; return; }
        newRoot.setAttribute('data-ddl-ajax-facets', '');
        newRoot.setAttribute('data-section-id', sectionId);
        root.replaceWith(newRoot);
        bindFacetsRoot(newRoot);
        newRoot.querySelectorAll('.ddl-animate').forEach(function (el) { el.classList.add('is-visible'); });
        newRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          // Keep the visible URL on the current page (e.g. /pages/tillier) —
          // targetUrl points at the twin collection used only for fetching;
          // only its query string (the applied filters) is worth reflecting.
          var query = targetUrl.split('?')[1] || '';
          history.replaceState(null, '', location.pathname + (query ? '?' + query : ''));
        } catch (e) {}
      })
      .catch(function () { window.location.href = targetUrl; });
  }

  // Pagination links + reset/clear-all links: plain <a href> that natively
  // navigate to the (twin) collection URL — intercept only inside an AJAX
  // facets root so brand pages stay in place; real collection pages keep
  // the native link behavior untouched.
  function initAjaxLinks(root) {
    root = root || document;
    root.querySelectorAll('.ddl-load-more-wrap .ddl-load-more-btn, .ddl-filter-clear-all, .ddl-reset-btn').forEach(function (link) {
      var ajaxRoot = link.closest('[data-ddl-ajax-facets]');
      if (!ajaxRoot) return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        fetchFacetsAjax(ajaxRoot, link.href);
      });
    });
  }

  function initSortSelect(root) {
    root = root || document;
    root.querySelectorAll('.ddl-sort-select').forEach(function (select) {
      select.addEventListener('change', function () {
        handleFacetSubmit(select.form);
      });
    });
  }

  function initCollectionFilters(root) {
    root = root || document;
    var filterForm = root.querySelector('.ddl-filter-form');
    if (!filterForm) return;

    // Auto-submit on checkbox change
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        handleFacetSubmit(filterForm);
      });
    });

    // "Appliquer" button / Enter key (needed for the price range, which
    // doesn't auto-submit on drag)
    filterForm.addEventListener('submit', function (e) {
      if (!filterForm.closest('[data-ddl-ajax-facets]')) return;
      e.preventDefault();
      handleFacetSubmit(filterForm);
    });

    // Remove badge
    root.querySelectorAll('[data-remove-filter]').forEach(function (badge) {
      badge.addEventListener('click', function () {
        var key   = badge.getAttribute('data-remove-filter');
        var value = badge.getAttribute('data-remove-value');
        var cb = filterForm.querySelector('input[type="checkbox"][name="' + key + '"][value="' + value + '"]');
        if (cb) { cb.checked = false; handleFacetSubmit(filterForm); }
      });
    });
  }

  /* =========================================================================
     10. PRICE SLIDER (dual-handle range)
     ========================================================================= */
  function initPriceSliders(root) {
    root = root || document;
    root.querySelectorAll('.ddl-price-slider-wrap').forEach(function (wrap) {
      var thumbA   = wrap.querySelector('.ddl-price-thumb--a');
      var thumbB   = wrap.querySelector('.ddl-price-thumb--b');
      var fill     = wrap.querySelector('.ddl-price-fill');
      var inputMin = wrap.querySelector('.ddl-price-input--min');
      var inputMax = wrap.querySelector('.ddl-price-input--max');
      var display  = wrap.nextElementSibling;
      var dispMin  = display ? display.querySelector('.ddl-price-disp--min') : null;
      var dispMax  = display ? display.querySelector('.ddl-price-disp--max') : null;
      var rangeMax = parseFloat(thumbA.max) || 1;

      function sync() {
        var a = parseFloat(thumbA.value);
        var b = parseFloat(thumbB.value);
        var lo = Math.min(a, b);
        var hi = Math.max(a, b);
        fill.style.left  = (lo / rangeMax * 100) + '%';
        fill.style.right = ((1 - hi / rangeMax) * 100) + '%';
        if (dispMin) dispMin.textContent = Math.round(lo) + ' €';
        if (dispMax) dispMax.textContent = Math.round(hi) + ' €';
        if (inputMin) inputMin.value = lo;
        if (inputMax) inputMax.value = hi;
      }

      thumbA.addEventListener('input', sync);
      thumbB.addEventListener('input', sync);
      sync();
    });
  }

  /* =========================================================================
     11. FACET GROUPS — voir plus / voir moins
     ========================================================================= */
  function initFacetGroups(root) {
    root = root || document;
    root.querySelectorAll('.ddl-filter-more-btn').forEach(function (btn) {
      var body    = btn.closest('.ddl-filter-body');
      var extras  = body ? body.querySelectorAll('.ddl-filter-extra') : [];
      var hidden  = parseInt(btn.getAttribute('data-hidden'), 10) || 0;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('data-expanded') === '1';
        extras.forEach(function (el) { el.style.display = expanded ? 'none' : ''; });
        btn.textContent = expanded ? 'Voir ' + hidden + ' de plus' : 'Voir moins';
        btn.setAttribute('data-expanded', expanded ? '0' : '1');
      });
    });
  }

  // Wires up everything inside one facets root (sidebar accordions, mobile
  // toggle, filter/sort submission, price slider, "voir plus", pagination —
  // called once for the whole document on load, and again on the fresh
  // fragment after an AJAX facets swap (fetchFacetsAjax above).
  function bindFacetsRoot(root) {
    root = root || document;
    root.querySelectorAll('.ddl-filter-section').forEach(function (el) {
      initFilterSection(el);
      el.classList.add('is-open');
    });
    initMobileFilter(root);
    initCollectionFilters(root);
    initPriceSliders(root);
    initFacetGroups(root);
    initSortSelect(root);
    initAjaxLinks(root);
  }

  /* =========================================================================
     12. WISHLIST (localStorage, keyed by product handle)
     ========================================================================= */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('ddl_wishlist') || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem('ddl_wishlist', JSON.stringify(list)); } catch (e) {}
    updateWishlistBadge();
  }
  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function initWishlist() {
    updateWishlistBadge();

    var btns = document.querySelectorAll('.ddl-btn--wishlist[data-product-handle]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var wishlist = getWishlist();
      if (wishlist.indexOf(handle) !== -1) btn.classList.add('is-active');

      btn.addEventListener('click', function () {
        var list = getWishlist();
        var idx  = list.indexOf(handle);
        if (idx === -1) { list.push(handle); btn.classList.add('is-active'); }
        else            { list.splice(idx, 1); btn.classList.remove('is-active'); }
        setWishlist(list);
      });
    });
  }

  /* =========================================================================
     13. RECENTLY VIEWED (localStorage + AJAX)
     ========================================================================= */
  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem('ddl_recently_viewed') || '[]'); } catch (e) { return []; }
  }
  function setRecentlyViewed(list) {
    try { localStorage.setItem('ddl_recently_viewed', JSON.stringify(list)); } catch (e) {}
  }

  function initRecentlyViewedTracking() {
    var marker = document.querySelector('[data-ddl-track-view]');
    var handle = marker ? marker.getAttribute('data-ddl-track-view') : '';
    if (!handle) return;

    var list = getRecentlyViewed();
    var idx = list.indexOf(handle);
    if (idx !== -1) list.splice(idx, 1);
    list.unshift(handle);
    if (list.length > 12) list = list.slice(0, 12);
    setRecentlyViewed(list);
  }

  function initRecentlyViewedDisplay() {
    var section = document.querySelector('[data-ddl-recently-viewed]');
    var grid = section ? section.querySelector('[data-ddl-recently-viewed-grid]') : null;
    if (!section || !grid) return;

    var exclude = section.getAttribute('data-exclude-handle') || '';
    var count = parseInt(section.getAttribute('data-count'), 10) || 4;
    var handles = getRecentlyViewed().filter(function (h) { return h && h !== exclude; }).slice(0, count);
    if (!handles.length) return;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (product) {
        grid.appendChild(buildRecentlyViewedCard(product));
      });
      if (grid.children.length) section.removeAttribute('hidden');
    });
  }

  function buildRecentlyViewedCard(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var price = variant.price || product.price || 0;
    var comparePrice = variant.compare_at_price || 0;
    var hasDiscount = comparePrice > price;
    var discountPct = hasDiscount ? Math.round((1 - price / comparePrice) * 100) : 0;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    if (image) image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    var isNew = product.created_at ? (Date.now() - new Date(product.created_at).getTime()) < 2592000000 : false;
    var isAvailable = variant.available !== undefined ? variant.available : product.available;
    var title = escapeHtml(product.title);

    var card = document.createElement('div');
    card.className = 'ddl-card';
    card.innerHTML =
      '<a href="' + product.url + '" class="ddl-card__image-link" aria-label="' + title + '">' +
        (image ? '<img class="ddl-card__image" src="' + image + '" alt="' + title + '" width="600" height="600" loading="lazy">' : '') +
        '<div class="ddl-card__badges">' +
          (isNew ? '<span class="ddl-badge ddl-badge--new">Nouveau</span>' : '') +
          (hasDiscount ? '<span class="ddl-badge ddl-badge--sale">-' + discountPct + '%</span>' : '') +
        '</div>' +
      '</a>' +
      '<div class="ddl-card__body">' +
        (product.vendor ? '<p class="ddl-card__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
        '<a href="' + product.url + '" class="ddl-card__title"><span>' + title + '</span></a>' +
        '<div class="ddl-card__footer">' +
          (isAvailable ?
            '<div class="ddl-card__price-wrap">' +
              '<span class="ddl-card__price">' + formatMoney(price) + '</span>' +
              (hasDiscount ? '<span class="ddl-card__price--compare">' + formatMoney(comparePrice) + '</span>' : '') +
            '</div>'
          : '') +
          '<div class="ddl-card__status">' +
            (isAvailable ? '<span class="ddl-status--stock">En stock</span>' : '<span class="ddl-status--preorder">Sur commande</span>') +
          '</div>' +
        '</div>' +
      '</div>';
    return card;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* =========================================================================
     13b. WISHLIST PAGE (localStorage + AJAX)
     ========================================================================= */
  function buildWishlistCard(product) {
    var card = buildRecentlyViewedCard(product);
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ddl-card__wishlist-remove';
    removeBtn.setAttribute('aria-label', 'Retirer des favoris');
    removeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    removeBtn.addEventListener('click', function () {
      var list = getWishlist();
      var idx = list.indexOf(product.handle);
      if (idx !== -1) list.splice(idx, 1);
      setWishlist(list);
      card.remove();
      var grid = document.querySelector('[data-ddl-wishlist-grid]');
      if (grid && !grid.children.length) {
        var section = document.querySelector('[data-ddl-wishlist]');
        if (section) section.setAttribute('data-empty', 'true');
      }
    });
    card.appendChild(removeBtn);
    return card;
  }

  function initWishlistPageDisplay() {
    var section = document.querySelector('[data-ddl-wishlist]');
    var grid = section ? section.querySelector('[data-ddl-wishlist-grid]') : null;
    if (!section || !grid) return;

    var handles = getWishlist();
    if (!handles.length) { section.setAttribute('data-empty', 'true'); return; }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (product) {
        grid.appendChild(buildWishlistCard(product));
      });
      section.setAttribute('data-empty', grid.children.length ? 'false' : 'true');
    });
  }

  /* =========================================================================
     11. INIT
     ========================================================================= */
  document.addEventListener('DOMContentLoaded', function () {

    // Gallery
    document.querySelectorAll('.ddl-gallery').forEach(function (gallery) {
      initGallery(gallery);
    });

    // Tabs
    document.querySelectorAll('.ddl-tabs-container').forEach(function (container) {
      initTabs(container);
    });

    // Accordions
    document.querySelectorAll('.ddl-accordion').forEach(function (el) {
      initAccordion(el);
    });

    // Quantity
    document.querySelectorAll('.ddl-qty-container').forEach(function (container) {
      initQuantity(container);
    });

    // Variant buttons
    document.querySelectorAll('.product-form').forEach(function (form) {
      initVariantButtons(form);
    });

    // Scroll animations
    initScrollAnimations();

    // Collection filters (sidebar accordions, mobile toggle, sort,
    // price slider, pagination — AJAX-aware for brand pages)
    bindFacetsRoot(document);

  // ── Hero Carousel ──────────────────────────────────────────────────────────
  function initHeroCarousel() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function(carousel) {
      var slides = carousel.querySelectorAll('.ddl-hero-carousel__slide');
      var dots   = carousel.querySelectorAll('.ddl-hero-carousel__dot');
      if (slides.length <= 1) return;

      var current  = 0;
      var total    = slides.length;
      var timer    = null;
      var interval = parseInt(carousel.dataset.interval, 10) || 2000;

      function goTo(idx) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = ((idx % total) + total) % total;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startAuto() {
        timer = setInterval(function() { goTo(current + 1); }, interval);
      }
      function stopAuto()  { clearInterval(timer); }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          stopAuto(); goTo(i); startAuto();
        });
      });

      startAuto();
    });
  }

  // ── GBP Reviews Carousel ─────────────────────────────────────────────────
  // Horizontal scroll-snap track showing 1-3 review cards at once depending
  // on viewport width; auto-advances one card at a time, pauses on hover/
  // focus so the copy stays readable, resumes after manual nav.
  function initGbpReviewsCarousel() {
    var carousels = document.querySelectorAll('[data-gbp-carousel]');
    carousels.forEach(function(carousel) {
      var track  = carousel.querySelector('[data-gbp-track]');
      var slides = carousel.querySelectorAll('[data-gbp-slide]');
      var dots   = carousel.querySelectorAll('[data-gbp-dot]');
      var prev   = carousel.querySelector('[data-gbp-prev]');
      var next   = carousel.querySelector('[data-gbp-next]');
      if (!track || slides.length <= 1) return;

      var current = 0;
      var total   = slides.length;
      var timer   = null;

      function updateDots() {
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === current);
          if (i === current) { dot.setAttribute('aria-current', 'true'); }
          else { dot.removeAttribute('aria-current'); }
        });
      }

      function goTo(idx) {
        current = ((idx % total) + total) % total;
        // Scroll only the track's own horizontal scrollbar — scrollIntoView()
        // was also nudging the page's vertical scroll to keep the slide in
        // view, yanking focus up to this section during autoplay.
        track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
        updateDots();
      }

      function startAuto() { timer = setInterval(function() { goTo(current + 1); }, 7000); }
      function stopAuto()  { clearInterval(timer); }

      if (prev) prev.addEventListener('click', function() { stopAuto(); goTo(current - 1); startAuto(); });
      if (next) next.addEventListener('click', function() { stopAuto(); goTo(current + 1); startAuto(); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { stopAuto(); goTo(i); startAuto(); });
      });

      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', startAuto);
      carousel.addEventListener('focusin', stopAuto);
      carousel.addEventListener('focusout', startAuto);

      startAuto();
    });
  }

  // ── Generic product carousel (prev/next arrows, no autoplay) ──
  function initDdlCarousel() {
    var carousels = document.querySelectorAll('[data-ddl-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-ddl-carousel-track]');
      var prev  = carousel.querySelector('[data-ddl-carousel-prev]');
      var next  = carousel.querySelector('[data-ddl-carousel-next]');
      if (!track) return;

      function scrollByCard(dir) {
        var card = track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * dir, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  // ── Hero-page overlay: remove MainContent padding-top set by syncSpacer ───
  function heroPageOverride() {
    if (!document.body.classList.contains('ddl-hero-page')) return;
    var mc = document.getElementById('MainContent');
    if (mc) mc.style.paddingTop = '0px';
  }



  
  // ── Mega Menu Collections (pleine largeur, survol) ──
  function initMegaMenu() {
    var trigger = document.getElementById('ddl-megamenu-trigger');
    var megamenu = document.getElementById('ddl-megamenu');
    var btn = document.getElementById('ddl-megamenu-btn');
    if (!trigger || !megamenu) return;

    var leaveTimer = null;

    function openMega() {
      clearTimeout(leaveTimer);
      // Close blog mega menu if open
      var blogMega = document.getElementById('ddl-blogmenu');
      if (blogMega) {
        blogMega.classList.remove('is-open');
        blogMega.setAttribute('aria-hidden', 'true');
        var blogBtn = document.getElementById('ddl-blogmenu-btn');
        if (blogBtn) blogBtn.setAttribute('aria-expanded', 'false');
      }
      megamenu.classList.add('is-open');
      megamenu.setAttribute('aria-hidden', 'false');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeMega() {
      leaveTimer = setTimeout(function() {
        megamenu.classList.remove('is-open');
        megamenu.setAttribute('aria-hidden', 'true');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }, 180);
    }

    trigger.addEventListener('mouseenter', openMega);
    trigger.addEventListener('mouseleave', closeMega);
    megamenu.addEventListener('mouseenter', openMega);
    megamenu.addEventListener('mouseleave', closeMega);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMega();
    });

    document.addEventListener('click', function(e) {
      if (!trigger.contains(e.target) && !megamenu.contains(e.target)) {
        megamenu.classList.remove('is-open');
        megamenu.setAttribute('aria-hidden', 'true');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });

    // Aperçu produits dynamique : bascule le panneau au survol de chaque colonne
    var cols = megamenu.querySelectorAll('[data-mega-col-index]');
    var panels = megamenu.querySelectorAll('[data-mega-preview]');
    if (cols.length && panels.length) {
      cols.forEach(function (col) {
        col.addEventListener('mouseenter', function () {
          var index = col.getAttribute('data-mega-col-index');
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-mega-preview') !== index;
          });
        });
      });
    }
  }

  // ── Mega Menu Blog (pleine largeur, survol) ──
  function initBlogMenu() {
    var trigger = document.getElementById('ddl-blogmenu-trigger');
    var blogmenu = document.getElementById('ddl-blogmenu');
    var btn = document.getElementById('ddl-blogmenu-btn');
    if (!trigger || !blogmenu) return;

    var leaveTimer = null;

    function openBlog() {
      clearTimeout(leaveTimer);
      // Close collections mega menu if open
      var colMega = document.getElementById('ddl-megamenu');
      if (colMega) {
        colMega.classList.remove('is-open');
        colMega.setAttribute('aria-hidden', 'true');
        var colBtn = document.getElementById('ddl-megamenu-btn');
        if (colBtn) colBtn.setAttribute('aria-expanded', 'false');
      }
      blogmenu.classList.add('is-open');
      blogmenu.setAttribute('aria-hidden', 'false');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeBlog() {
      leaveTimer = setTimeout(function() {
        blogmenu.classList.remove('is-open');
        blogmenu.setAttribute('aria-hidden', 'true');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }, 180);
    }

    trigger.addEventListener('mouseenter', openBlog);
    trigger.addEventListener('mouseleave', closeBlog);
    blogmenu.addEventListener('mouseenter', openBlog);
    blogmenu.addEventListener('mouseleave', closeBlog);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeBlog();
    });

    document.addEventListener('click', function(e) {
      if (!trigger.contains(e.target) && !blogmenu.contains(e.target)) {
        blogmenu.classList.remove('is-open');
        blogmenu.setAttribute('aria-hidden', 'true');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

    // Wishlist
    initWishlist();
    // Mega menu Collections
    initMegaMenu();
    // Mega menu Blog
    initBlogMenu();

    // Hero Carousel
    initHeroCarousel();
    initGbpReviewsCarousel();
    initDdlCarousel();
    heroPageOverride();
    setTimeout(heroPageOverride, 500);


    // Header
    initHeader();

    // Product info drawer
    (function() {
      var overlay = document.getElementById('ddl-drawer-overlay');
      var drawer  = document.getElementById('ddl-drawer');
      var titleEl = document.getElementById('ddl-drawer-title');
      var bodyEl  = document.getElementById('ddl-drawer-body');
      var closeBtn = document.getElementById('ddl-drawer-close');
      if (!drawer) return;

      var infoJustOpened = false;

      function openDrawer(title, content) {
        infoJustOpened = true;
        titleEl.textContent = title;
        bodyEl.innerHTML = content;
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
        requestAnimationFrame(function() { requestAnimationFrame(function() { infoJustOpened = false; }); });
      }
      function closeDrawer() {
        overlay.classList.remove('is-open');
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });
      document.addEventListener('click', function(e) {
        if (infoJustOpened || !drawer.classList.contains('is-open')) return;
        if (!drawer.contains(e.target)) closeDrawer();
      });

      document.querySelectorAll('[data-drawer-target]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var contentEl = document.getElementById('ddl-content-' + btn.dataset.drawerTarget);
          if (contentEl) openDrawer(btn.dataset.drawerTitle || '', contentEl.innerHTML);
        });
      });
    })();

    // Demande de disponibilité / précommande — tiroir latéral
    (function() {
      var drawer = document.getElementById('ddl-preorder-drawer');
      if (!drawer) return;
      var overlay  = document.getElementById('ddl-drawer-overlay');
      var closeBtn = document.getElementById('ddl-preorder-close');

      function openPreorder() {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        // On donne le focus au bouton de fermeture, pas au 1er champ : focaliser un
        // input ferait scroller le tiroir et masquerait l'explication des étapes.
        if (closeBtn) closeBtn.focus();
        var body = drawer.querySelector('.ddl-drawer__body');
        if (body) body.scrollTop = 0;
      }
      function closePreorder() {
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      document.querySelectorAll('[data-preorder-open]').forEach(function(btn) {
        btn.addEventListener('click', function(e) { e.preventDefault(); openPreorder(); });
      });
      if (closeBtn) closeBtn.addEventListener('click', closePreorder);
      if (overlay) overlay.addEventListener('click', closePreorder);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closePreorder();
      });

      // Retour de Shopify après envoi réussi → rouvrir sur la confirmation
      if (drawer.querySelector('[data-preorder-posted]')) openPreorder();
    })();

    // Buy Now — add to cart then redirect to checkout
    (function() {
      var buyNowBtn = document.getElementById('ddl-buy-now');
      if (!buyNowBtn) return;
      buyNowBtn.addEventListener('click', function() {
        var form = document.getElementById('product-form');
        if (!form) return;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '…';
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function() { window.location.href = '/checkout'; })
          .catch(function() { buyNowBtn.disabled = false; buyNowBtn.textContent = 'Acheter maintenant'; });
      });
    })();

    // Click & Collect — add to cart + checkout.
    // Shopify's checkout has no cart attribute, line item property, or URL
    // parameter that preselects the "Pickup" delivery tab — the customer has
    // to pick it manually there (see the hint text next to the button).
    // The property below is purely informational (visible on the order),
    // it does not affect checkout behaviour.
    (function() {
      var ccBtn = document.getElementById('ddl-click-collect');
      if (!ccBtn) return;
      ccBtn.addEventListener('click', function() {
        var form = document.getElementById('product-form');
        if (!form) return;
        ccBtn.style.opacity = '0.6';
        ccBtn.style.pointerEvents = 'none';
        var data = new FormData(form);
        // Note visible sur la commande à l'intention du magasin, sans effet sur le checkout
        data.append('properties[Retrait en magasin]', 'Oui');
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function() { window.location.href = '/checkout'; })
          .catch(function() { ccBtn.style.opacity = ''; ccBtn.style.pointerEvents = ''; });
      });
    })();

    // Gallery mobile dots — sync dots with scroll position
    (function() {
      var gallery = document.querySelector('.ddl-gallery');
      var dotsWrap = document.getElementById('ddl-gallery-dots');
      if (!gallery || !dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.ddl-gallery-dot');
      var items = gallery.querySelectorAll('.ddl-gallery__item');
      if (!dots.length || !items.length) return;

      // Scroll observer
      var scrollTimeout;
      gallery.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var scrollLeft = gallery.scrollLeft;
          var itemWidth = items[0].offsetWidth;
          var idx = Math.round(scrollLeft / itemWidth);
          idx = Math.max(0, Math.min(idx, dots.length - 1));
          dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
        }, 50);
      });

      // Click on dot → scroll to image
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.dataset.index, 10);
          var target = items[idx];
          if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      });
    })();

    // Sticky CTA — show only when main add-to-cart is out of view
    (function() {
      var mainBtn = document.querySelector('#product-form [name="add"], #product-form [data-preorder-open]');
      var stickyBar = document.getElementById('ddl-sticky-cta');
      if (!mainBtn || !stickyBar) return;
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.5 });
      obs.observe(mainBtn);
    })();

    // Cart Drawer
    initCartDrawer();

    // Recently viewed
    initRecentlyViewedTracking();
    initRecentlyViewedDisplay();

    // Wishlist page
    initWishlistPageDisplay();

  });

  /* =========================================================
     HEADER — scroll shrink, search bar, mobile menu
     ========================================================= */

  function initHeader() {
    var header  = document.getElementById('ddl-header');
    var spacer  = document.getElementById('ddl-header-spacer');
    var burger  = document.getElementById('ddl-burger');
    var mobileMenu  = document.getElementById('ddl-mobile-menu');
    var mobileClose = document.getElementById('ddl-mobile-close');
    var overlay     = document.getElementById('ddl-mobile-overlay');
    var searchBtn   = document.getElementById('ddl-search-btn');
    var searchBar   = document.getElementById('ddl-search-bar');
    var searchClose = document.getElementById('ddl-search-close');
    var searchInput = document.getElementById('ddl-search-input');

    if (!header) return;

    // ---- Scroll shrink ----
    function onScroll() {
      var scrolled = window.scrollY > 10;
      header.classList.toggle('is-scrolled', scrolled);
      if (spacer) spacer.classList.toggle('is-scrolled', scrolled);
      // Re-sync after transition settles
      setTimeout(syncSpacer, 420);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Sync clearance with the header's measured height.
    // MainContent's padding-top is the only thing reserving room for the fixed
    // header, so it must match header height exactly — never more. Page-opening
    // whitespace is --ddl-page-top's job.
    var mainContent = document.getElementById('MainContent');
    var isHeroPage = document.body.classList.contains('ddl-hero-page');
    function syncSpacer() {
      if (!header) return;
      // --ddl-header-h always carries the real measured header height: other
      // components (the hero's top padding) read it to clear the fixed bar.
      // Only the page clearance is zeroed on a full-bleed hero page.
      var headerH = header.offsetHeight;
      document.documentElement.style.setProperty('--ddl-header-h', headerH + 'px');
      var clearance = isHeroPage ? 0 : headerH;
      if (spacer) spacer.style.height = clearance + 'px';
      if (mainContent) {
        mainContent.style.setProperty('padding-top', clearance + 'px', 'important');
      }
    }
    window.addEventListener('resize', syncSpacer);
    syncSpacer();
    // Re-sync once webfonts have swapped in: guessing at arbitrary delays
    // (50ms/300ms) risked landing mid font-swap, catching the header at an
    // intermediate height and writing that half-settled value into
    // MainContent's padding-top — shifting the entire page under it. Firing
    // once the browser confirms fonts are actually ready removes that race.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncSpacer);
    } else {
      setTimeout(syncSpacer, 300);
    }

    // ---- Mobile menu ----
    function openMenu() {
      header.classList.add('menu-open');
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      header.classList.remove('menu-open');
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger && mobileMenu) {
      burger.addEventListener('click', function() {
        mobileMenu.classList.contains('is-open') ? closeMenu() : openMenu();
      });
    }
    if (mobileClose) mobileClose.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeMenu(); closeSearch(); }
    });

    // Mobile submenu accordions
    document.querySelectorAll('.ddl-mobile-nav-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('.ddl-mobile-nav-item--has-sub');
        if (!item) return;
        var isOpen = item.getAttribute('data-open') === 'true';
        document.querySelectorAll('.ddl-mobile-nav-item--has-sub').forEach(function(el) {
          el.setAttribute('data-open', 'false');
          el.querySelector('.ddl-mobile-nav-trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // ---- Search bar ----
    function openSearch() {
      if (!searchBar) return;
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      if (searchInput) setTimeout(function() { searchInput.focus(); }, 50);
    }
    function closeSearch() {
      if (!searchBar) return;
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    }
    var searchBtnMobile = document.getElementById('ddl-search-btn-mobile');
    if (searchBtn) searchBtn.addEventListener('click', openSearch);
    if (searchBtnMobile) searchBtnMobile.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    // Desktop dropdown click toggle + outside close
    var dropdownTriggers = document.querySelectorAll('#ddl-header .ddl-nav-link--trigger');
    dropdownTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        dropdownTriggers.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
        if (!expanded) btn.setAttribute('aria-expanded', 'true');
      });
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('#ddl-header .ddl-nav-item--has-dropdown')) {
        dropdownTriggers.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  /* =========================================================================
     12. CART DRAWER
     ========================================================================= */
  function initCartDrawer() {
    var overlay  = document.getElementById('ddl-cart-overlay');
    var drawer   = document.getElementById('ddl-cart-drawer');
    var closeBtn = document.getElementById('ddl-cart-close');
    var badge    = document.getElementById('ddl-cart-badge');
    if (!drawer) return;

    var cartJustOpened = false;

    function openCartDrawer() {
      cartJustOpened = true;
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      fetchAndRenderCart();
      requestAnimationFrame(function() { requestAnimationFrame(function() { cartJustOpened = false; }); });
    }

    function closeCartDrawer() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });
    document.addEventListener('click', function(e) {
      if (cartJustOpened || !drawer.classList.contains('is-open')) return;
      if (!drawer.contains(e.target)) closeCartDrawer();
    });

    // Header cart icon opens drawer
    document.querySelectorAll('a[href="/cart"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    function fetchAndRenderCart() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() {});
    }

    function fmtMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    function renderCart(cart) {
      var itemsEl  = document.getElementById('ddl-cart-items');
      var emptyEl  = document.getElementById('ddl-cart-empty');
      var footerEl = document.getElementById('ddl-cart-footer');
      var subtotalEl = document.getElementById('ddl-cart-subtotal');
      if (!itemsEl) return;

      var count = cart.item_count || 0;
      var totalPrice = cart.total_price || 0;

      // Update badges
      if (badge) badge.textContent = count;
      document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function(el) {
        el.textContent = count;
      });

      // Always update progress bar regardless of cart state

      if (count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl)  { emptyEl.style.display = 'flex'; }
        if (footerEl) { footerEl.style.display = 'none'; }
      } else {
        if (emptyEl)  { emptyEl.style.display = 'none'; }
        if (footerEl) { footerEl.style.display = 'block'; }
        if (subtotalEl) subtotalEl.textContent = fmtMoney(totalPrice);

        itemsEl.innerHTML = cart.items.map(function(item) {
          var imgSrc = item.featured_image ? item.featured_image.url : '';
          var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          var qtyMinus = item.quantity - 1; // 0 removes the item
          var qtyPlus  = item.quantity + 1;
          return (
            '<li class="ddl-cart-item" data-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="ddl-cart-item__image-link">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" class="ddl-cart-item__image" width="88" height="88" loading="lazy">' : '') +
            '</a>' +
            '<div class="ddl-cart-item__info">' +
              '<div class="ddl-cart-item__top">' +
                '<div>' +
                  '<div class="ddl-cart-item__title">' + item.product_title + '</div>' +
                  (variantTitle ? '<div class="ddl-cart-item__variant">' + variantTitle + '</div>' : '') +
                '</div>' +
                '<button type="button" class="ddl-cart-item__remove" data-key="' + item.key + '" aria-label="Supprimer">' +
                  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="ddl-cart-item__bottom">' +
                '<span class="ddl-cart-item__price">' + fmtMoney(item.line_price) + '</span>' +
                '<div class="ddl-cart-item__qty-wrap">' +
                  '<button type="button" class="ddl-cart-item__qty-btn" data-key="' + item.key + '" data-qty="' + qtyMinus + '" aria-label="Diminuer">−</button>' +
                  '<span class="ddl-cart-item__qty-value">' + item.quantity + '</span>' +
                  '<button type="button" class="ddl-cart-item__qty-btn" id="ddl-drawer-plus-' + item.key + '" data-key="' + item.key + '" data-qty="' + qtyPlus + '" aria-label="Augmenter">+</button>' +
                '</div>' +
              '</div>' +
              '<p id="ddl-item-stock-' + item.key + '" class="ddl-cart-item__stock-warning" style="display:none" aria-live="polite"></p>' +
            '</div>' +
            '</li>'
          );
        }).join('');

        itemsEl.querySelectorAll('.ddl-cart-item__qty-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var li = btn.closest('.ddl-cart-item');
            // Disable both buttons immediately: a second rapid click would otherwise
            // reuse the same pre-computed data-qty (baked in at the last render) and
            // silently no-op instead of decrementing/incrementing further.
            if (li) {
              li.querySelectorAll('.ddl-cart-item__qty-btn').forEach(function(b) { b.disabled = true; });
            }
            changeItem(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10), li);
          });
        });
        itemsEl.querySelectorAll('.ddl-cart-item__remove').forEach(function(btn) {
          btn.addEventListener('click', function() {
            changeItem(btn.getAttribute('data-key'), 0);
          });
        });
      }
    }

    function changeItem(key, qty, li) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) {
        return r.json().then(function(data) {
          if (r.status >= 400 || data.description) {
            var msg = 'Quantité maximale disponible atteinte.';
            var itemErrEl = document.getElementById('ddl-item-stock-' + key);
            if (itemErrEl) {
              itemErrEl.textContent = msg;
              itemErrEl.style.display = 'block';
              setTimeout(function() { itemErrEl.style.display = 'none'; }, 5000);
            }
            if (li) {
              li.querySelectorAll('.ddl-cart-item__qty-btn').forEach(function(b) { b.disabled = false; });
            }
            var plusBtn = document.getElementById('ddl-drawer-plus-' + key);
            if (plusBtn) {
              plusBtn.disabled = true;
              plusBtn.classList.add('ddl-cart-item__qty-btn--disabled');
            }
            return null;
          }
          return data;
        });
      })
      .then(function(cart) { if (cart) renderCart(cart); })
      .catch(function() {
        if (li) {
          li.querySelectorAll('.ddl-cart-item__qty-btn').forEach(function(b) { b.disabled = false; });
        }
      });
    }

    // Intercept all add-to-cart form submits
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      // Don't intercept if it's the buy-now flow (handled separately)
      if (form.dataset.buyNow) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[name="add"]');
      var originalHTML = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function() {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalHTML; }
          openCartDrawer();
        })
        .catch(function() {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalHTML; }
        });
    });

    // Initial badge count
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { if (badge) badge.textContent = cart.item_count || 0; })
      .catch(function() {});
  }


  /* ── WELCOME OFFER — copie du code + pré-application via /discount/CODE ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-ddl-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-ddl-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function() {});
    // Shopify mémorise le code (cookie) et l'applique automatiquement au paiement
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function() {});
    var hint = btn.querySelector('.ddl-welcome__copy-hint') || btn;
    var original = hint.textContent;
    hint.textContent = btn.getAttribute('data-copied-label');
    btn.classList.add('is-copied');
    setTimeout(function() { hint.textContent = original; btn.classList.remove('is-copied'); }, 2000);
  });

})();
